// extracted by mini-css-extract-plugin
export default {"arrowsBox":"arrowsBox-e1bf","tableContainer":"tableContainer-9c4b","mainRow":"mainRow-0c5d"};